// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__1wwhm","disabled":"FileBtn_disabled__2pQFe","warn":"FileBtn_warn__3Z9Ia","fade":"FileBtn_fade__3KTej"};